/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Templates_MoveInputs */



/**
* | output |
* | --- |
* | "Move {name}" |
*
* @param {Settings_Templates_MoveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_move = /** @type {((inputs: Settings_Templates_MoveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_MoveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Verplaats ${i?.name}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déplacer ${i?.name}`)
	return /** @type {LocalizedString} */ (`Move ${i?.name}`)
});